import { Dispatch, useState } from "react";
import axios from 'axios';
import { ManifestProps, ServiceWorkerType, eNAEPComponents } from "../types";
import { IADPActions } from "../state/Actions";
import { actions } from "../state";
import { environment } from "../util/util";
import { useServiceWorkerRegistration } from "./useServiceWorkerRegistration";
import { useResolveServiceStatus } from "./useNetworkService";
import { useDedupEffect } from "../util/useDedupEffect";
import { indexDBStorage } from "../storage/indexDBStorage";
import pkgJson from "../../../package.json";
const logPrefix = "[ADPClient][ConfigServiceHook]"

export function usePlatformVersionService(dispatch:Dispatch<IADPActions>) {
  const {serviceWorkerRegistration} = useServiceWorkerRegistration(dispatch);
  const [manifest, setManifest] = useState<ManifestProps>();
  const {isDeviceOnlineWithAccessToNAEPCloud} = useResolveServiceStatus(dispatch)
  async function fetchADPBuildJson() {
    return new Promise((resolve):void => {
      console.log(logPrefix,"fetching adp version...");
      axios.get(`${environment.resolveENAEPDomain()}/adp-chrome-app/build.json?no-cache=${Date.now()}`)
    .then(function (response) {
      console.log(logPrefix,"fetchADPBuildJson status", response.status);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.ADP,
        serverVersion: response?.data?.version
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
      resolve(true);
    })
    .catch(function (error) {
      // handle error
      console.log(logPrefix,"error fetching adp version",error);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.ADP,
        serverVersionError: `error fetching adp version: ${error?.code},${error?.name},${error?.message}`
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
      resolve(false);
    })
    })
   
  }
  async function fetchADCBuildJson() {
    return new Promise((resolve):void => {
      console.log(logPrefix,"fetching ade version...");
      axios.get(`${environment.resolveENAEPDomain()}/ade/build.json?no-cache=${Date.now()}`)
    .then(function (response) {
      console.log(logPrefix,"fetchADEBuildJson status", response.status);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.ADC,
        serverVersion: response?.data?.version
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
      resolve(true);
    })
    .catch(function (error) {
      // handle error
      console.log(logPrefix,"error fetching adc version",error);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.ADC,
        serverVersionError: `error fetching adc version: ${error?.code},${error?.name},${error?.message}`
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
      resolve(false);
    })
    })
   
  }
  async function fetchSCIBuildJson() {
    return new Promise((resolve):void => {
      console.log(logPrefix,"fetching sci version...");
      axios.get(`${environment.resolveENAEPDomain()}/login/build.json?no-cache=${Date.now()}`)
    .then(function (response) {
      console.log(logPrefix,"fetchSCIBuildJson  status", response.status);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.SCI,
        serverVersion: response?.data?.version
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
      resolve(true);
    })
    .catch(function (error) {
      // handle error
      console.log(logPrefix,"error fetching sci version",error);
      const serviceWorkerDetails: ServiceWorkerType = {
        appCode: eNAEPComponents.SCI,
        serverVersionError: `error fetching sci version: ${error?.code},${error?.name},${error?.message}`
      }
      dispatch(actions.createUpdateServiceWorkerDetailsAction(serviceWorkerDetails));
       resolve(false);
    })
    })
  };

  function fetchManifest() {
    const currentPath = window.location.href.replace("index.html", "");
    //fetch manifest - TODO - move to service worker
    console.log(logPrefix,"fetching adp manifest...");
    const fetchPromise = fetch(`${currentPath}manifest/naep.manifest.json?v=${pkgJson.version}`);
    fetchPromise.then(response => {
      console.log(logPrefix,"manifest fetch status", response.status);
      return response.json();
    }).then(async function (manifest) {
    let releaseVersion = manifest?.manifest?.product;
    try {
      const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","localReleaseVersion");
      if(updateRecord){
        releaseVersion.version = updateRecord;
      }
      else {
        (await indexDBStorage.getInstance()).transactions.put("adp-session-references",releaseVersion.version,"localReleaseVersion");
      }
    }catch(e){
      console.warn(logPrefix,"error updating release version in indexDB");
    }
    const transformedManifest:ManifestProps = {
      release : releaseVersion,
      app: manifest?.manifest?.app
    };
    if(await isDeviceOnlineWithAccessToNAEPCloud()){
      await fetchADPBuildJson();
      await fetchADCBuildJson();
      await fetchSCIBuildJson();
    }
    setManifest(transformedManifest);
  })
  .catch(function (error) {
    // handle error
    console.log(logPrefix,"error fetching manifest",error);
     dispatch(actions.createSetViewAction("LoadingErrroView"));
  })
  }
  useDedupEffect(() => {
    if(!serviceWorkerRegistration)return;
    fetchManifest();
  }, [serviceWorkerRegistration]);
  return manifest;
}
